// @flow
import client from '../../client'
import format from '../../utils/format'

// Types
type Data = {
  id: string,
  first_name?: string,
  last_name?: string,
  email_address?: string,
  pickup_datetime?: string,
}

// Constants
export const GET_RESERVATION_BY_CONFIRMATION_NUMBER_ENDPOINT =
  '/reservations/customer_reservation/{0}/'

/**
 * Get Reservation by confirmation number
 * @param {Object} data Reservation information
 * @param {string} data.id Reservation ID
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const getReservationByConfirmationNumber = (
  data: Data
): Promise<any> => {
  const { id, ...query } = data
  const endpoint = format(
    GET_RESERVATION_BY_CONFIRMATION_NUMBER_ENDPOINT,
    data.id
  )
  return client.get(endpoint, { query })
}

export default getReservationByConfirmationNumber
